/**
 * Renders ranged-enemy projectiles in flight.
 * Props: projectiles (array from s.projectiles)
 */
export function ProjectileLayer({ projectiles }) {
  if (!projectiles?.length) return null;

  return projectiles.map(proj => (
    <div
      key={proj.id}
      className={`dq-projectile dq-projectile--${proj.damageType ?? 'physical'}`}
      style={{ transform: `translate3d(${proj.x}px,${proj.y}px,0)` }}
    />
  ));
}
